export const ANCHOR_SERVICES = {
  CHAT: 'chatSaaS',
  CHAT_TEMPTED: 'chatSaaS-tempted',
  STREAM: 'streaming',
  SOCIAL_MEDIA: 'socialMedia',
};
